import * as React from 'react';
import { Typography, Grid2 as Grid } from '@mui/material';
import Heading from '../elements/heading';
import { HeroWithCTA } from '../../types/blocks/hero-with-cta';
import { CallToActionButton } from '../elements/call-to-action-button';

interface HeroWithCTAProps {
  element: HeroWithCTA;
}

export const HeroWithCTABlock: React.FC<HeroWithCTAProps> = ({ element }) => (
  <div
    style={{
      backgroundRepeat: 'repeat',
      backgroundSize: 'contain',
    }}
  >
    <div className="space-y-12 py-16 px-4">
      <Heading title={element.title} subtitle={element.subtitle} />
      <div>
        {!!element.image.url && (
          <img src={element.image.url} className="w-full h-auto max-w-[1060px] mx-auto" />
        )}

        {!!element.card && (
          <div className="md:min-h-[250px] max-w-[800px] rounded-2xl mx-auto overflow-hidden bg-paper p-10 flex items-center mt-8 md:mt-y-[-50px] lg:mt-[-150px] relative">
            <Grid
              container
              className="z-10 space-y-1 md:space-y-2 justify-center md:justify-start"
              rowSpacing={2}
            >
              <Grid size={{ xs: 12, sm: 6, lg: 7 }}>
                <Typography
                  variant="title-mac-sans-xl"
                  component="h4"
                  className="text-primary-contrastText hidden sm:block"
                >
                  {element.card.description}
                </Typography>
                <Typography variant="mac-sans-h2" component="h4" className="text-center sm:hidden">
                  {element.card.description}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, lg: 5 }}>
                <div className="h-full flex items-center justify-center md:justify-end items-center">
                  <CallToActionButton
                    button={element.card.callToAction}
                    className="my-auto"
                    textClassName="whitespace-nowrap"
                  />
                </div>
              </Grid>
            </Grid>
            {!!element.card?.image?.url && (
              <img src={element.card.image.url} className="absolute left-[-80px] bottom-0" />
            )}
          </div>
        )}
      </div>
    </div>
  </div>
);
